export class ListSparkEnginesRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "filters",
            "baseName": "filters",
            "type": "ListSparkEnginesFilterConditions",
            "format": ""
        },
        {
            "name": "sorts",
            "baseName": "sorts",
            "type": "Array<SortSparkEngineBy>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListSparkEnginesRequest.attributeTypeMap;
    }
    constructor() {
    }
}
